import firebase from "firebase";
import api from "../../../../services/api";
import Header from '../../../../components/Header.vue'

export default {

    components: {
        Header,
    },

    data() {
        return {

            loading: true,

            dadosEmpresa: null,
            dadosEmissao: false,
            taxaAdm: "",
            bgColor: "#a1a1a1",

            documentacao: [],
            logo: "",
            listaImgRg: [], // monta html
            listaCarteiraConselho: [], // monta html
            listaInscricaoPis: [], // monta html
            listaTituloEleitor: [], // monta html
            listaCCM: [], // monta html
            listaEndereco: [], // monta html
            listaDadosBancarios: [], // monta html
            listaDependentes: [], // monta html
            listaNegativaConselho: [], // monta html
            listaDiploma: [], // monta html
            listaVacinacao: [], // monta html
            listaCurriculo: [], // monta html
            listaCriminais: [], // monta html
            listaAssinaturaCarimboCoren: [], // monta html
            listaBlocoVariavel_1500: [], // monta html
            listaBlocoVariavel_1510: [], // monta html
            listaBlocoVariavel_1520: [], // monta html
            listaBlocoVariavel_1530: [], // monta html
            listaBlocoVariavel_1540: [], // monta html


            nomeFoto: [],
            fotoPerfil: null,
            botaoVisivel: true,
            enderecoEdit: true,

            estadoCivil: ["SOLTEIRO(A)", "CASADO(A)", "DIVORCIADO(A)", "SEPARADO(A)", "VIÚVO(A)"],

            racas: [
                "BRANCA",
                "PRETA",
                "PARDA",
                "AMARELA",
                "INDÍGENA",
                "NÃO INFORMADO",
            ],

            sexo: ["MASCULINO", "FEMININO"],
            fumante: ["SIM", "NÃO"],

            labelDadosAdicionais: '',

            escolaridades: [],
            paises: [],
            bancos: [],

            listaConhecimentosTecnicos: [],

            tipoContas: ["CORRENTE", "POUPANÇA"],

            //   dispPlantoes: [],
            listaPlantoes: [
                { text: "Diurno Impar", value: "diaImpar" },
                { text: "Diurno Par", value: "diaPar" },
                { text: "Noturno Impar", value: "noiteImpar" },
                { text: "Noturno Par", value: "noitePar" },
            ],

            //   selProcedimentos: [],
            listaProcedimentos: [
                { text: "Manhã", value: "manha" },
                { text: "Tarde", value: "tarde" },
                { text: "Noite", value: "noite" },
            ],

            tiposDependentes: [],
            dependente: {
                nome: null,
                cpf: null,
                dataNasc: null,
                tipo: null,
            },
            editarDep: false,
            editarIndex: 0,

            fields: [
                { key: "nome", label: "Nome" },
                { key: "cpf", label: "CPF" },
                {
                    key: "dataNasc",
                    label: "Data Nascimento",
                    formatter: (value) => {
                        const dataView = value.split("-");
                        return `${dataView[2]}/${dataView[1]}/${dataView[0]}`;
                    },
                },
                { key: "parentesco", label: "Tipo dependente" }

            ],

            hoje: new Date().toISOString().substr(0, 10),

            form: {
                nome: "",
                email: "",
                cpf: "",
                estadoCivil: "",
                nacionalidade: "",
                escolaridade: "",
                raca: "",
                dataNasc: "",
                sexo: "",
                restFisica: "",
                fumante: "",
                dadosAdic: "",
                rg: "",
                rgOrgaoEmissor: "",
                rgDataExp: "",
                nomeFuncao: "",
                regProf: "",
                regNum: "",
                regDataVencimento: "",
                pis: "",
                tituloEleitor: "",
                ccm: "",
                cep: "",
                cidade: "",
                uf: "",
                bairro: "",
                endereco: "",
                numEndereco: "",
                complemento: "",
                celular: "",
                celAdic: "",
                fixo: "",
                banco: "",
                agencia: "",
                conta: "",
                contaDig: "",
                tipoConta: "",
                chavePix: "",
                nomeBeneficiario: "",
                cpfBeneficiario: "",
                nomeBeneficiarioObito: "",
                tipoBeneficiarioObito: null,
                tipoBeneficiarioOutroTexto: "",
                file1: "",
                dependentes: [],
                urlFotoPerfil: null,
                urlRg: [],
                urlCarteiraConselho: [],
                urlInscricaoPis: [],
                urlTituloEleitor: [],
                urlCCM: [],
                urlEndereco: [],
                urlDadosBancarios: [],
                urlDependentes: [],
                urlNegativaConselho: [],
                urlDiploma: [],
                urlVacinacao: [],
                urlCurriculo: [],
                urlAntCriminais: [],
                urlAssinaturaCarimboCoren: [],
                urlBlocoVariavel_1500: [],
                urlBlocoVariavel_1510: [],
                urlBlocoVariavel_1520: [],
                urlBlocoVariavel_1530: [],
                urlBlocoVariavel_1540: [],
                ufNascimento: "",
                cidadeNascimento: "",
                nomeMae: "",
                nomePai: "",
                nomeConjuge: "",
                cliente: "",
                dataInicio: "",
                taxaAdmSelecionada: null,
                opcoesTaxasAdm: [],
                numeroContrato: '',
            },

            show: true,
            img1: false,
            img2: false,

            blocosReprovados: [],

        };
    },

    async created() {
        const dadosEmpresa = this.$store.state.empresaSelecionada
        this.dadosEmpresa = dadosEmpresa
        this.bgColor = dadosEmpresa.cor
        this.logo = dadosEmpresa.logoPath
        this.blocos = dadosEmpresa.blocos

        await this.getcarregarTaxasAdm();
        await this.getBlocosVisiveisDaFuncao()
        await this.getSolicitacao()

        if (dadosEmpresa.indAnexo === 'sim') {
            this.dadosEmissao = true;
            /* this.form.numeroContrato = dadosEmpresa.numero_contrato; */
        }

        this.loading = false
    },

    methods: {


        msg(titulo, texto, cor, time = 10000) {
            this.toastCount++;
            this.$bvToast.toast(texto, {
                title: titulo,
                variant: cor,
                solid: true,
                autoHideDelay: time,
                appendToast: true,
            });
        },

        blocoVisivel(codBloco, contemImagem) {

            // console.log(codBloco, this.blocos)
            let visivel = false

            if (contemImagem == 'sim') {
                // Busca especificamente por bloco de imagem
                this.blocos.forEach(item => {
                    if (item.cod == codBloco && item.visivel == 'sim' && item.imagem == contemImagem)
                        visivel = true
                })
            } else if (contemImagem === undefined || contemImagem === null) {
                // Quando não especifica, verifica se existe versão sem imagem OU se é bloco só de imagem
                const temVersaoSemImagem = this.blocos.some(
                    item => item.cod == codBloco && item.visivel == 'sim' && item.imagem != 'sim'
                )
                const temVersaoComImagem = this.blocos.some(
                    item => item.cod == codBloco && item.visivel == 'sim' && item.imagem == 'sim'
                )

                // Retorna true se tem versão sem imagem OU se só tem versão com imagem (bloco standalone)
                visivel = temVersaoSemImagem || (temVersaoComImagem && !temVersaoSemImagem)
            } else {
                // contemImagem == 'não' ou outro valor - busca por versão sem imagem
                this.blocos.forEach(item => {
                    if (item.cod == codBloco && item.visivel == 'sim' && item.imagem != 'sim')
                        visivel = true
                })
            }

            return visivel
        },

        blocoObrigatorio(codBloco) {

            // console.log(codBloco, this.blocos)
            let obrigatorio = false
            this.blocos.forEach(item => {
                // console.log('item', item)
                if (item.cod == codBloco && item.obrigatorio == 'sim')
                obrigatorio = true
            })

            return obrigatorio
        },

        textoTitulo(codBloco, contemImagem) {

            let texto = ''

            if (contemImagem == 'sim') {

                this.blocos.forEach(item => {

                    if (item.cod == codBloco && item.imagem == contemImagem) texto = item.titulo

                })

            } else if (contemImagem == 'não') {

                this.blocos.forEach(item => {

                    if (item.cod == codBloco && item.imagem != 'sim') texto = item.titulo

                })

            } else {
                // Quando não especifica, prioriza bloco sem imagem (formulário)
                // Se não existir versão sem imagem, usa a versão com imagem
                const blocoSemImagem = this.blocos.find(
                    item => item.cod == codBloco && item.imagem != 'sim'
                );
                const blocoComImagem = this.blocos.find(
                    item => item.cod == codBloco && item.imagem == 'sim'
                );
                texto = blocoSemImagem ? blocoSemImagem.titulo : (blocoComImagem ? blocoComImagem.titulo : '');
            }

            return texto
        },

        textoBloco(codBloco, contemImagem) {
            let texto = ''

            if (contemImagem == 'sim') {
                this.blocos.forEach(item => {
                    if (item.cod == codBloco && item.imagem == contemImagem)
                        texto = item.instrucoes
                })
            } else if (contemImagem == 'não') {
                this.blocos.forEach(item => {
                    if (item.cod == codBloco && item.imagem != 'sim')
                        texto = item.instrucoes
                })
            } else {
                // Quando não especifica, prioriza bloco sem imagem (formulário)
                // Se não existir versão sem imagem, usa a versão com imagem
                const blocoSemImagem = this.blocos.find(
                    item => item.cod == codBloco && item.imagem != 'sim'
                );
                const blocoComImagem = this.blocos.find(
                    item => item.cod == codBloco && item.imagem == 'sim'
                );
                texto = blocoSemImagem ? blocoSemImagem.instrucoes : (blocoComImagem ? blocoComImagem.instrucoes : '');
            }

            return texto
        },

        blocoReprovado(codBloco) {
            return this.blocosReprovados.some(item => item.cod == codBloco)
        },

        textoBlocoMotivoRep(codBloco, contemImagem) {
            // Só mostra motivo de reprovação se status = 8 (Cadastro reprovado - ajustes)
            if (this.form.status != 8) return ''

            let texto = ''

            if (contemImagem == 'sim') {
                const bloco = this.blocosReprovados.find(
                    item => item.cod == codBloco && item.imagem == contemImagem
                )
                texto = bloco?.motivo || ''
            } else if (contemImagem == 'não') {
                const bloco = this.blocosReprovados.find(
                    item => item.cod == codBloco && item.imagem != 'sim'
                )
                texto = bloco?.motivo || ''
            } else {
                const bloco = this.blocosReprovados.find(item => item.cod == codBloco)
                texto = bloco?.motivo || ''
            }

            return texto
        },

        voltar() {
            this.$router.push("/candidatos");
        },

        selecionarImagem(arquivo, listaImg) {
            // console.log('arquivo',arquivo.target.id)
            const nomeTratado = this.tratarNomeImg(arquivo.target.files[0].name)
            const urlTemp = this.getUrlTemp(arquivo.target.files[0])
            listaImg.push({ nome: nomeTratado, url: urlTemp })
            this.onUpload(arquivo.target.files[0], arquivo.target.id, nomeTratado)
        },

        getUrlTemp(image) {
            // console.log(image)
            return URL.createObjectURL(image)
        },

        previwFoto(e) {
            // var tagId = e.target.id
            if (e.target.id == 'foto-perfil') {
                this.form.urlFotoPerfil = URL.createObjectURL(e.target.files[0])
                const nomeTratado = this.tratarNomeImg(e.target.files[0].name)
                this.onUpload(e.target.files[0], e.target.id, nomeTratado)
            }
        },


        async getBlocosVisiveisDaFuncao() {

            const idSolicitacao = localStorage.getItem('idSolicitacao')

            try {
                
                const res = await api.get("web-cliente/candidato/blocos-visiveis-funcao/" + idSolicitacao)

                const blocosVisiveis = res.data
                // console.log('blocosVisiveis', blocosVisiveis)
                this.blocos = blocosVisiveis?.length > 0 
                ? this.blocos.filter(bloco => {
                    return blocosVisiveis.find(blocoVisivel => Number(blocoVisivel) == bloco.cod)
                })
                : this.blocos

                // console.log('this.blocos',this.blocos)
               
            } catch (error) {
                if (!this.dadosEmpresa) this.$router.push("/adesao/erro");  
            }

        },

        async getcarregarTaxasAdm() {
            try {
              const res =  await api.get('/web-cliente/candidato/taxas-admnistrativas')
              this.opcoesTaxasAdm = res.data.map(item => ({
                value: item,
                text: `${item.descricao} - ${Number(item.taxa_adm).toFixed(2).replace('.', ',')}%`
              }))              
            } catch (e) {
              console.error('Erro ao carregar taxas administrativas', e)
            }
        },


        async getSolicitacao() {

            const idSolicitacao = localStorage.getItem('idSolicitacao')
            const dadosEmpresa = this.$store.state.empresaSelecionada

            this.escolaridades = dadosEmpresa.escolaridades;
            this.paises = dadosEmpresa.paises;
            this.bancos = dadosEmpresa.bancos;
            this.tiposDependentes = dadosEmpresa.tiposDependentes;


            try {
                
                const res = await api.get("web-cliente/candidato/documentacao/" + idSolicitacao)

                // console.log('res.data', res.data);

                this.form = res.data
                this.blocosVisiveis = res.data.blocosVisiveis
                this.listaConhecimentosTecnicos = res.data.listaConhecimentosTecnicos
                this.blocosReprovados = res.data.blocosReprovados || []


                this.form.cliente = res.data.cliente || ''
                this.form.dataInicio = res.data.data_inicio
                  ? res.data.data_inicio.split('T')[0]
                  : ''
                this.taxaAdm = res.data.taxa_adm
                  ? res.data.taxa_adm.toFixed(2).replace('.', ',')
                  : ''

                // Atribui o objeto da opção cujo id bate com o codRubrico salvo
                const codRubrica = Number(res.data.codRubrica)
                this.form.taxaAdmSelecionada = this.opcoesTaxasAdm.find(
                opcao => opcao.value.id === codRubrica
                )?.value || null
            
                this.numeroContrato = res.data.numeroContrato || null;
                

                this.imgRg = this.form.urlRg
                this.listaImgRg = this.form.urlRg.map(item => {
                    return {
                        nome: item.split('%')[1].split('?')[0],
                        url: item
                    }
                })

                this.listaInscricaoPis = this.form.urlInscricaoPis.map(item => {
                    return {
                        nome: item.split('%')[1].split('?')[0],
                        url: item
                    }
                })

                this.listaTituloEleitor = this.form.urlTituloEleitor.map(item => {
                    return {
                        nome: item.split('%')[1].split('?')[0],
                        url: item
                    }
                })

                this.listaCCM = this.form.urlCCM.map(item => {
                    return {
                        nome: item.split('%')[1].split('?')[0],
                        url: item
                    }
                })

                this.listaEndereco = this.form.urlEndereco.map(item => {
                    return {
                        nome: item.split('%')[1].split('?')[0],
                        url: item
                    }
                })

                this.listaDadosBancarios = this.form.urlDadosBancarios.map(item => {
                    return {
                        nome: item.split('%')[1].split('?')[0],
                        url: item
                    }
                })

                this.listaDependentes = this.form.urlDependentes.map(item => {
                    return {
                        nome: item.split('%')[1].split('?')[0],
                        url: item
                    }
                })

                this.listaCarteiraConselho = this.form.urlCarteiraConselho.map(item => {
                    return {
                        nome: item.split('%')[1].split('?')[0],
                        url: item
                    }
                })

                this.listaNegativaConselho = this.form.urlNegativaConselho.map(item => {
                    return {
                        nome: item.split('%')[1].split('?')[0],
                        url: item
                    }
                })

                this.listaDiploma = this.form.urlDiploma.map(item => {
                    return {
                        nome: item.split('%')[1].split('?')[0],
                        url: item
                    }
                })

                this.listaVacinacao = this.form.urlVacinacao.map(item => {
                    return {
                        nome: item.split('%')[1].split('?')[0],
                        url: item
                    }
                })

                this.listaCurriculo = this.form.urlCurriculo.map(item => {
                    return {
                        nome: item.split('%')[1].split('?')[0],
                        url: item
                    }
                })

                this.listaCriminais = this.form.urlAntCriminais.map(item => {
                    return {
                        nome: item.split('%')[1].split('?')[0],
                        url: item
                    }
                })

                this.listaAssinaturaCarimboCoren = this.form.urlAssinaturaCarimboCoren.map(item => {
                    return {
                        nome: item.split('%')[1].split('?')[0],
                        url: item
                    }
                })

                this.listaBlocoVariavel_1500 = this.form.urlBlocoVariavel_1500.map(item => {
                    return {
                        nome: item.split('%')[1].split('?')[0],
                        url: item
                    }
                })

                this.listaBlocoVariavel_1510 = this.form.urlBlocoVariavel_1510.map(item => {
                    return {
                        nome: item.split('%')[1].split('?')[0],
                        url: item
                    }
                })

                this.listaBlocoVariavel_1520 = this.form.urlBlocoVariavel_1520.map(item => {
                    return {
                        nome: item.split('%')[1].split('?')[0],
                        url: item
                    }
                })

                this.listaBlocoVariavel_1530 = this.form.urlBlocoVariavel_1530.map(item => {
                    return {
                        nome: item.split('%')[1].split('?')[0],
                        url: item
                    }
                })

                this.listaBlocoVariavel_1540 = this.form.urlBlocoVariavel_1540.map(item => {
                    return {
                        nome: item.split('%')[1].split('?')[0],
                        url: item
                    }
                })




            } catch (error) {
                console.log(error)
                this.msg("ATENÇÃO", 'Erooooooooooooooooooo', "danger");
                // return
                // if (!this.dadosEmpresa) this.$router.push("/adesao/erro");  
            }

        },






        tratarNomeImg(nomeImg) {
            console.log('nomeImg', nomeImg)
            const nome = nomeImg.split(".");
            const agora = Math.floor(Date.now());
            const ext = nome[nome.length - 1];

            return agora + "." + ext;
        },



        async onUpload(file, nomeVariavel) {

            if (!file) return
            // console.log("file", file)

            try {
                const storageRef = firebase.storage().ref()

                this.form.urlImage = null;
                const nomeImg = this.tratarNomeImg(file.name)
                this.nomeFoto.push(nomeImg)

                const metadata = {
                    contentType: "image/jpeg"
                };

                const fileRef = storageRef.child(`fotos_perfil/${nomeImg}`)
                const uploadTaskSnapshot = await fileRef.put(file, metadata)
                    // this.form.urlFotoPerfil = await uploadTaskSnapshot.ref.getDownloadURL()


                if (nomeVariavel == 'foto-perfil') this.form.urlFotoPerfil = await uploadTaskSnapshot.ref.getDownloadURL()
                else
                if (nomeVariavel == 'rg-frente') this.form.urlRgFrente = await uploadTaskSnapshot.ref.getDownloadURL()
                else
                if (nomeVariavel == 'rg-verso') this.form.urlRgVerso = await uploadTaskSnapshot.ref.getDownloadURL()
                else
                if (nomeVariavel == 'carteira-conselho-frente') this.form.urlCarteiraConselhoFrente = await uploadTaskSnapshot.ref.getDownloadURL()
                else
                if (nomeVariavel == 'carteira-conselho-verso') this.form.urlCarteiraConselhoVerso = await uploadTaskSnapshot.ref.getDownloadURL()
                else
                if (nomeVariavel == 'negativa-conselho') this.form.urlNegativaConselho = await uploadTaskSnapshot.ref.getDownloadURL()
                else
                if (nomeVariavel == 'diploma-frente') this.form.urlDiplomaFrente = await uploadTaskSnapshot.ref.getDownloadURL()
                else
                if (nomeVariavel == 'diploma-verso') this.form.urlDiplomaVerso = await uploadTaskSnapshot.ref.getDownloadURL()
                else
                if (nomeVariavel == 'vacinacao-frente') this.form.urlVacinacaoFrente = await uploadTaskSnapshot.ref.getDownloadURL()
                else
                if (nomeVariavel == 'vacinacao-verso') this.form.urlVacinacaoVerso = await uploadTaskSnapshot.ref.getDownloadURL()
                else
                if (nomeVariavel == 'curriculo') this.form.urlCurriculo = await uploadTaskSnapshot.ref.getDownloadURL()
                else
                if (nomeVariavel == 'ant-criminais') this.form.urlAntCriminais = await uploadTaskSnapshot.ref.getDownloadURL()
                else
                if (nomeVariavel == 'ant-criminais') this.form.urlAssinaturaCarimboCoren = await uploadTaskSnapshot.ref.getDownloadURL()


            } catch (error) {
                console.log("ERR ===", error)
                    //alert("Image uploading failed!")
            }

        },




    },

    computed: {
        cssVars() {
            return {
                "--bg-color": this.bgColor,
                "--height": this.height + "px",
            };
        },
        textoParentescoBeneficiarioObito() {
            if (this.form.tipoBeneficiarioObito && this.tiposDependentes?.length) {
                const tipo = this.tiposDependentes.find(t => t.value == this.form.tipoBeneficiarioObito);
                return tipo?.text || '';
            }
            return '';
        },
    },


};